var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.max
    ? _c(
        "b-form-group",
        {
          staticClass: "label-text-wrapper",
          scopedSlots: _vm._u(
            [
              {
                key: "label",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _vm.label
                          ? _c("div", [
                              _c("span", { staticClass: "label-text" }, [
                                _vm._v(_vm._s(_vm.label)),
                              ]),
                              _vm._v(" "),
                              _vm.copy
                                ? _c("i", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName:
                                          "v-b-tooltip.hover.viewport.noninteractive",
                                        value: _vm.copied
                                          ? "Copied!"
                                          : "Duplicate text field",
                                        expression:
                                          "copied ? 'Copied!' : 'Duplicate text field'",
                                        modifiers: {
                                          hover: true,
                                          viewport: true,
                                          noninteractive: true,
                                        },
                                      },
                                    ],
                                    class: [
                                      "cursor-pointer font-xl pr-2 bi pl-0",
                                      _vm.copied ? "bi-check2" : "bi-copy",
                                    ],
                                    staticStyle: {
                                      "font-size": "0.75rem !important",
                                    },
                                    attrs: { "data-action": "copy" },
                                    on: { click: _vm.copyTextToClipboard },
                                  })
                                : _vm._e(),
                            ])
                          : _vm._t("label"),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant:
                                    _vm.state === null ? "success" : "danger",
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.count) +
                                    "/" +
                                    _vm._s(_vm.max) +
                                    "\n        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.maxEditable
                              ? _c("b-icon", {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    id: "edit-max-chars",
                                    icon: "pencil",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.maxEditable
                              ? _c(
                                  "b-popover",
                                  {
                                    attrs: {
                                      target: "edit-max-chars",
                                      placement: "bottomleft",
                                      show: _vm.popoverShow,
                                    },
                                    on: {
                                      "update:show": function ($event) {
                                        _vm.popoverShow = $event
                                      },
                                    },
                                  },
                                  [
                                    _c("b-input", {
                                      staticClass: "mb-2",
                                      model: {
                                        value: _vm.editableMaxChars,
                                        callback: function ($$v) {
                                          _vm.editableMaxChars = $$v
                                        },
                                        expression: "editableMaxChars",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "primary" },
                                        on: { click: _vm.editMaxCharsHandler },
                                      },
                                      [
                                        _vm._v(
                                          "\n            Update\n          "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            125715265
          ),
        },
        [_vm._v(" "), _vm._t("default", null, { state: _vm.state })],
        2
      )
    : _c(
        "b-form-group",
        { attrs: { label: _vm.label } },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }